<div class="edit-page-root-container shop-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            @if (this.userData?.user_type == 'SHOP') {
            <div class="page-title">

                <img class="icon" src="assets/images/menu/svg/shop.svg" width="30" height="30"><span class="title">
                    {{title}}</span>
            </div>

            }

            @if (this.userData?.user_type == 'HQ') {
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            }

            <div class="action-btn-container">
                @if (userData?.user_type === 'HQ' && shopInfo.id && shopInfo.id !== 0 && shopInfo.is_initially_synced ==
                0) {
                <button mat-flat-button class="action-btn btn-publish" (click)="publish()"
                    style="background-color: #2e7d32; color: white; margin-right: 8px;">PUBLISH</button>
                }
                @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left"> <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" maxlength="50" appCodeInput
                                        style="text-transform: uppercase;"
                                        [readonly]="shopInfo.id!==undefined && shopInfo.id!==0">
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">code should
                                        be entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                                        10.</mat-error>
                                </mat-form-field></div>

                            <div class="input-box-right"> <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Shop name should
                                        be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                                        50.</mat-error>
                                </mat-form-field></div>

                        </div>


                        <mat-form-field class="description">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                            <mat-error *ngIf="editForm.controls['description'].hasError('maxlength')">Maximum length is
                                200.</mat-error>
                        </mat-form-field>
                        @if (this.userData?.user_type == 'HQ') {
                        <div class="shop-mapping-container">
                            <mat-form-field class="shop-type-container">
                                <mat-label>Shop Type</mat-label>
                                <mat-select formControlName="shop_type" [(ngModel)]="selected_shop_type"
                                    (ngModelChange)="onShopTypeChange()">
                                    <mat-option *ngFor="let shoptypes of shoptype" [value]="shoptypes.code">
                                        {{ shoptypes.code }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div id="sushishop" *ngIf="is_display_bento_shop" class="mainshop-container">
                                <mat-form-field class="mainshop">
                                    <mat-label>Sushi Shop</mat-label>

                                    <mat-select formControlName="main_shop_id" [(ngModel)]="mainShop">
                                        <mat-option *ngFor="let mainshop of mainshop_list" [value]="mainshop.id">
                                            {{ mainshop.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div id="dt-sushishop" *ngIf="is_display_dt_shops" class="dt-container">
                                <mat-form-field class="dt-sushi">
                                    <mat-label>Sushi Shop</mat-label>

                                    <mat-select formControlName="dt_sushi_shop_id" [(ngModel)]="selectedSushiShop">
                                        <mat-option *ngFor="let sushishop of sushishop_list" [value]="sushishop.id">
                                            {{ sushishop.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div id="bendoshop" *ngIf="is_display_dt_shops" class="dt-container">
                                <mat-form-field class="dt-bento">
                                    <mat-label>Bento Shop</mat-label>

                                    <mat-select formControlName="dt_bento_shop_id" [(ngModel)]="selectedBentoShop">
                                        <mat-option *ngFor="let bentoshop of bento_shop_list" [value]="bentoshop.id">
                                            {{ bentoshop.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        }






                        <!-- 
                        <div class="input-group">
                            <div class="input-box-left" >
                                 <mat-form-field class="code" style="width: 135px;">
                                <mat-label>Shop Type</mat-label>
                                <mat-select formControlName="shop_type" [(ngModel)]="selected_shop_type"
                                (ngModelChange)="onShopTypeChange()">
                                <mat-option *ngFor="let shoptypes of shoptype" [value]="shoptypes.code">
                                    {{ shoptypes.code }}
                                </mat-option>
                            </mat-select>
                                </mat-form-field></div>

                            <div class="input-box-right">
                                <div id="sushishop" *ngIf="is_display_bento_shop">
                                    <mat-form-field>
                                        <mat-label>Sushi Shop</mat-label>
    
                                        <mat-select formControlName="main_shop_id" [(ngModel)]="mainShop">
                                            <mat-option *ngFor="let mainshop of mainshop_list" [value]="mainshop.id">
                                                {{ mainshop.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div id="dt-sushishop" class="dt-shop" *ngIf="is_display_dt_shops">
                                    <mat-form-field>
                                        <mat-label>Sushi Shop</mat-label>
    
                                        <mat-select formControlName="dt_sushi_shop_id" [(ngModel)]="selectedSushiShop">
                                            <mat-option *ngFor="let sushishop of sushishop_list" [value]="sushishop.id">
                                                {{ sushishop.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div id="bendoshop" class="dt-shop" *ngIf="is_display_dt_shops">
                                    <mat-form-field>
                                        <mat-label>Bento Shop</mat-label>
    
                                        <mat-select formControlName="dt_bento_shop_id" [(ngModel)]="selectedBentoShop">
                                            <mat-option *ngFor="let bentoshop of bento_shop_list" [value]="bentoshop.id">
                                                {{ bentoshop.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                
                            </div>

                        </div> -->






                        @if (this.userData?.user_type == 'HQ' && isProductionMode) {
                        <mat-checkbox formControlName="is_excluded_summary">Exclude From HQ
                            Summary</mat-checkbox>
                        }









                        <mat-form-field>
                            <mat-label>Address</mat-label>

                            <textarea matInput formControlName="address"></textarea>
                        </mat-form-field>

                        <div class="address-content">
                            <mat-form-field class="area-container">
                                <mat-label>Area</mat-label>
                                <mat-select formControlName="area_id">
                                    <mat-option *ngFor="let area of areaList" [value]="area.id">
                                        {{ area.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="">
                                <mat-label>Zip Code</mat-label>
                                <input matInput formControlName="zip_code">
                            </mat-form-field>

                        </div>
                        <div class="address-content">
                            <mat-form-field class="address-container">
                                <mat-label>City</mat-label>
                                <input matInput formControlName="city">
                            </mat-form-field>
                            <mat-form-field class="address-container">
                                <mat-label>State</mat-label>

                                <input matInput formControlName="state">
                            </mat-form-field>
                            <mat-form-field class="address-container">
                                <mat-label>Country</mat-label>

                                <input matInput formControlName="country">
                            </mat-form-field>
                        </div>
                        @if (this.userData?.user_type == 'HQ' && shopInfo.id && shopInfo.id !== 0) {
                        <div class="address-content" style="align-items: center;">

                            <mat-form-field class="address-container">
                                <mat-label>Start Date</mat-label>
                                <input matInput [matDatepicker]="startDatePicker" formControlName="start_date" readonly>
                                <mat-datepicker-toggle matSuffix [for]="startDatePicker"
                                    [disabled]="true"></mat-datepicker-toggle>
                                <mat-datepicker #startDatePicker></mat-datepicker>
                            </mat-form-field>

                            @if (shopInfo.is_initially_synced != 0 && shopInfo.is_in_production_mode == 0) {
                            <button type="button" class="btn-enable-prod" (click)="enableProductionMode()">
                                <mat-icon class="btn-icon-left">rocket_launch</mat-icon>
                                <span class="btn-text">Enable Production Mode</span>
                                <mat-icon class="btn-icon-right">chevron_right</mat-icon>
                            </button>
                            }
                        </div>
                        }








                    </div>
                </div>

                @if (this.userData?.user_type == 'HQ') {

                <div class="detail-section">
                    <div class="content-container">
                        <div class="sub-title">Payroll Settings</div>


                        <div class="input-group">
                            <mat-form-field appearance="fill" class="payroll-group-name" style="min-width:220px;">
                                <mat-label>Payroll Group Name</mat-label>
                                <input type="text" matInput [matAutocomplete]="payrollGroupAuto"
                                    [formControl]="payrollGroupSearch"
                                    (input)="filterPayrollGroups(payrollGroupNameInput.value)"
                                    (blur)="editForm.controls['payroll_group_id'].markAsTouched()"
                                    #payrollGroupNameInput>
                                <button *ngIf="editForm.value.payroll_group_id" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="clearPayrollGroup()">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <mat-autocomplete #payrollGroupAuto="matAutocomplete"
                                    (optionSelected)="selectPayrollGroup($event)">
                                    <mat-option *ngFor="let group of filteredPayrollGroups" [value]="group">
                                        {{ group.group_name }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <mat-form-field class="cost-code">
                                <mat-label>Cost Code</mat-label>
                                <input matInput formControlName="cost_code" maxlength="10">
                                <mat-error *ngIf="editForm.controls['cost_code'].hasError('maxlength')">Maximum length
                                    is 10.</mat-error>
                            </mat-form-field>
                        </div>

                    </div>
                </div>
                }

            </form>
            <div class="detail-section">
                <div class="content-container">
                    <div class="sub-title">Department</div>
                    <table class="table table-bordered" style="width:100%;">
                        <thead>
                            <tr>

                                <th>SL</th>
                                <th style="text-align: left;">CODE</th>
                                <th style="text-align: left;">NAME</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let dept of shopInfo.departments;  let i=index;">

                                <td style="text-align: center;">{{ i+1 }}</td>
                                <td style="text-align: left;">{{ dept.code }}</td>
                                <td style="text-align: left;">{{ dept.name }}</td>
                                <td style="text-align: left;">
                                    <mat-checkbox [(ngModel)]="dept.is_exist" (change)="onDepartmentChange(dept)"
                                        [ngModelOptions]="{standalone: true}"></mat-checkbox>

                                </td>

                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
            <!-- <div class="dept-container">
                <div class="sub-title">Department</div>
                <div class="section-content order-value-discount-amount">
                    <div class="input-container">
                        <div class="input-row">
                            <div formArrayName="departments">
                                <div *ngFor="let department of departmentControls.controls; let i = index"
                                    [formGroupName]="i">
                                    <label>
                                        <input type="checkbox" [formControlName]="i" />
                                        {{ department.value.name }}
                                    </label>
                                </div>
                            </div> -->
            <!-- <table class="table table-bordered" style="width:100%;">
                            <thead>
                              <tr>
                               
                                <th>SL</th>
                                <th style="text-align: left;">CODE</th>
                                <th style="text-align: left;">NAME</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let dept of departmentControls.controls;  let i=index;" [formGroupName]="i">
                                
                                <td style="text-align: center;">{{ i+1 }}</td>
                                <td style="text-align: left;">{{ dept.value.code }}</td>
                                <td style="text-align: left;">{{ dept.value.name }}</td>
                                <td style="text-align: left;">
                                    <input type="checkbox" [formControlName]="i" />
                                    {{ dept.value.name }}
                                </td>
                                   
                              </tr>
                            </tbody>
                          </table> -->
            <!-- <table mat-table [dataSource]="departmentList">
                            
    
                            <ng-container matColumnDef="code">
                                <th mat-header-cell *matHeaderCellDef>CODE </th>
                                <td mat-cell *matCellDef="let element"> {{element.code}}
                                </td>
                            </ng-container>
    
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef> NAME </th>
                                <td mat-cell *matCellDef="let element">{{element.name}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="">
                                <th mat-header-cell *matHeaderCellDef>  </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-checkbox formControlName="dept_ids"></mat-checkbox>
                                </td>
                            </ng-container>
    
                            
                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
                            </tr>
                            <tr mat-row *matRowDef = "let row; columns: displayedColumns;"></tr>
    
                        </table> -->



            <!-- </div>
                    </div>
                </div>
            </div> -->
            <!-- ............................... -->

        </div>
    </div>
</div>

<ng-template #publishDialog>
    <h2 mat-dialog-title>Publish Shop</h2>
    <mat-dialog-content style="overflow: hidden;">
        <div
            style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 200px; min-width: 350px; position: relative; overflow: hidden;">
            <app-loader [show]="isPublishing"></app-loader>
            <div *ngIf="!isPublishing" style="margin-top: 20px; font-weight: bold; text-align: center; font-size: 16px;"
                [ngStyle]="{'color': publishSuccess ? '#2e7d32' : '#d32f2f'}">
                <mat-icon style="font-size: 48px; width: 48px; height: 48px; margin-bottom: 15px;">{{ publishSuccess ?
                    'check_circle' : 'error' }}</mat-icon><br>
                {{ publishStatusMessage }}
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" *ngIf="!isPublishing">
        <button mat-button (click)="closePublishDialog()">Close</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #prodModeWarningDialog>
    <div class="warning-dialog-card">
        <div class="dialog-banner">
            <div class="warning-icon-wrapper">
                <mat-icon class="warning-icon">warning</mat-icon>
            </div>
            <div class="banner-title">WARNING</div>
        </div>

        <div class="dialog-body">
            <ng-container *ngIf="prodModeStep === 1">
                <div class="step1-content">
                    <p class="main-msg">
                        This action will switch the shop to Production Mode and permanently delete all existing data
                        from the
                        shop database.
                    </p>
                    <p class="note-msg">
                        Note: This action cannot be undone.
                    </p>

                    <div class="dialog-actions-row">
                        <button type="button" mat-flat-button class="btn-proceed" (click)="goToProductionModeStep2()">
                            PROCEED
                        </button>
                        <button type="button" mat-stroked-button class="btn-cancel"
                            (click)="cancelEnableProductionMode()">
                            CANCEL
                        </button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="prodModeStep === 2">
                <div class="step2-content">
                    <p class="step2-instruction">
                        To send summarized sales data to HQ, ensure the checkbox below is enabled. </p>
                    <div class="step2-checkbox-container">
                        <mat-checkbox color="primary" [(ngModel)]="isSummarizeSalesToHq"
                            [ngModelOptions]="{standalone: true}">
                            Summarize sales to HQ
                        </mat-checkbox>
                    </div>
                    <p class="step2-note">
                        Important: If this option is disabled, no sales data from this shop will be sent to HQ, and the
                        shop's sales will be excluded from all HQ reports.
                    </p>

                    <div class="dialog-actions-row">
                        <button type="button" mat-flat-button class="btn-proceed"
                            (click)="confirmEnableProductionMode()">
                            PROCEED
                        </button>
                        <button type="button" mat-stroked-button class="btn-cancel"
                            (click)="cancelEnableProductionMode()">
                            CANCEL
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #prodModeLoaderDialog>
    <h2 mat-dialog-title>Enabling Production Mode</h2>
    <mat-dialog-content style="overflow: hidden;">
        <div
            style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 200px; min-width: 350px; position: relative; overflow: hidden;">
            <app-loader [show]="isSettingProdMode"></app-loader>
            <div *ngIf="!isSettingProdMode"
                style="margin-top: 20px; font-weight: bold; text-align: center; font-size: 16px;"
                [ngStyle]="{'color': prodModeSuccess ? '#2e7d32' : '#d32f2f'}">
                <mat-icon style="font-size: 48px; width: 48px; height: 48px; margin-bottom: 15px;">{{ prodModeSuccess ?
                    'check_circle' : 'error' }}</mat-icon><br>
                {{ prodModeStatusMessage }}
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" *ngIf="!isSettingProdMode">
        <button mat-button (click)="closeProdModeLoaderDialog()">Close</button>
    </mat-dialog-actions>
</ng-template>